import { BaseComponent } from '../../../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../../../components/Box';
import { Modal, ModalControls } from '../../../../../../components/Modal';
import { Button } from '../../../../../../components/Buttons';
import { Checkbox } from '../../../../../../components/Checkbox';
import { VehicleCreateField } from './Fields';
import { selectConfig, selectUserId, selectWork, selectWorks } from '../../../../../Api/selectors';
import { fetchCompanies, getCompanyWorkflows, updateAddress } from '../../../../../Companies/actions';
import {
  calculatePurchasePriceInclVatExclBPM,
  fetchVehicles,
  setNewVehicleValue,
  setNewVehicle,
  setVehicleProperty,
} from '../../../../actions';
import { REQUEST_COMPANIES, REQUEST_COMPANY_WORKFLOWS } from '../../../../../Companies/constants';
import { REQUEST_HOME_COMPANY_USERS } from '../../../../../Users/constants';
import { selectNewVehicle, selectNewVehicleValue } from '../../../../selectors';
import { selectCompany, selectCompanyWorkflows } from '../../../../../Companies/selectors';
import { selectAddressTypes } from '../../../../../Address/selectors';
import { getPropByName } from '../../../../../../utils/props';
import {
  CALCULATE_PURCHASE_PRICES_INCL_VAT_EXCL_BPM,
  REQUEST_VEHICLE_CREATE,
  VEHICLE_PURPOSE,
  VEHICLE_TAX_TYPE,
} from '../../../../constants';
import { PURCHASING_PRICES_CRUD } from '../../../../../../components/Permission/constants';
import { Permission } from '../../../../../../components/Permission';
import env from '../../../../../../env';
import { WIENTJES_INSTALATION, AUTOHUISSALLAND_INSTALATION } from '../../../../../../containers/App/constants';
import { fetchWorkflows } from '../../../../../Workflows/actions';
import { REQUEST_WORKFLOWS, REQUEST_WORKFLOWS_FILTER } from '../../../../../Workflows/constants';
import { selectWorkflows } from '../../../../../Workflows/selectors';
import { AppClientId } from '../../../../../Shared/constants';
import ModalComponent from '../../../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../../../containers/App/Components/Button/Button';
import CheckboxComponent from '../../../../../../containers/App/Components/Checkbox/Checkbox';
import styles from './AddVehicleModalBase.module.css';
import { Loader } from '../../../../../../components/Loader';
import { makeSelectLocale } from '../../../../../../containers/LanguageProvider/selectors';
import { translateCountry } from '../../../../../Companies/translate-countries';

const STATE = {
  address: null,
  saveStrategy: null,
  tasks: {},
};

const TRANSPORT_TYPES = {
  PICKUP: 'pickup',
  DELIVER: 'develiver',
  IS_AVAILABLE: 'is_available',
  OTHER: 'anders',
};

// Constants for field validation
const REQUIRED_FIELDS = {
  workflowId: {
    field: 'workflowId',
    message: 'Workflow is verplicht *',
    condition: (values, clientId) => clientId === AppClientId.HILTERMANN && !values.workflowId,
  },
  vehicle_purpose: {
    field: 'vehicle_purpose',
    message: 'Type Voertuig is verplicht *',
    condition: (values, clientId) => clientId === AppClientId.HILTERMANN && !values.vehicle_purpose,
  },
  is_owner: {
    field: 'is_owner',
    message: 'Eigenaar is verplicht *',
    condition: (values, clientId) => clientId === AppClientId.AUTOHUISSALLAND && !values.is_owner,
  },
};

// Styled Components
const Container = styled.div`
  font-size: 14px;

  .req-field-message {
    color: red;
  }

  .title {
    font-size: 14px;
  }

  .calendar-block {
    width: 100%;
  }

  .address-section {
    width: 100%;
  }

  .address-block {
    margin-bottom: 8px;
    width: 100%;
  }

  h5 {
    margin-bottom: 16px;
  }

  .cell:first-child {
    text-transform: capitalize;
  }

  .col {
    width: 100%;
    padding-right: 48px;
  }

  .info-card {
    width: 100%;
    h2 {
      margin-bottom: 24px;
    }
    .btn {
      margin: 6px;
    }
  }
`;

const Address = styled.div`
  border: ${props => (!!props.isActive ? '1px solid rgb(21, 172, 121)' : '1px solid grey')};
  padding: 12px;
  width: calc(50% - 10px);
  margin: 8px 0;
  font-size: 12px;
  min-height: 120px;

  @media (max-width: 768px) {
    width: 100%;
  }

  .button {
    margin: 0 -12px;
  }
  .name {
    font-size: 12px;
  }
  .address {
    margin-top: 12px;
  }

  .req-field-message {
    color: red;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class AddVehicleModalBaseComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.initializeData();
  }

  componentDidUpdate(prevProps, prevState) {
    this.handleTransportUpdates();
    this.removeUnavailableTasks();
  }

  // Initialization methods
  initializeData = () => {
    this.props.fetch();
    this.props.getCompanyWorkflows();
    this.props.fetchWorkflows();
    this.setState({ creditorCompany: this.props.creditorCompany });

    if (this.props.tradeInVehicle) {
      this.props.setValue('marge', 'tax_type');
    }
  };

  // Transport handling methods
  handleTransportUpdates = () => {
    const { values } = this.props;
    if (!values?.transport) return;

    if (values.transport === TRANSPORT_TYPES.DELIVER) {
      this.handleDeliveryTransport();
    } else if (
      (!values.location_address_id &&
        (values.transport === TRANSPORT_TYPES.PICKUP || values.transport === TRANSPORT_TYPES.IS_AVAILABLE)) ||
      values.transport === TRANSPORT_TYPES.OTHER
    ) {
      this.handlePickupTransport();
    }
  };

  handleDeliveryTransport = () => {
    this.props.setValue(this.props.creditorCompanyId, 'location_company_id');
    if (this.homeAddress?.[0]?.postcode) {
      this.props.setValue(this.homeAddress[0].postcode, 'transport_from_address_postcode');
    }
    this.props.setValue(this.homeAddress[0]?.id, 'location_address_id');
  };

  handlePickupTransport = () => {
    this.props.setValue(this.props.creditorCompanyId, 'location_company_id');
    if (this.homeAddress?.[0]?.postcode) {
      this.props.setValue(this.homeAddress[0].postcode, 'transport_from_address_postcode');
    }
    this.props.setValue(this.homeAddress[0]?.id, 'location_address_id');
  };

  // Task management methods
  removeUnavailableTasks = () => {
    const availableTasks = this.availableTasks;
    if (Object.entries(this.state.tasks).find(([t, value]) => value === 1 && !availableTasks.includes(t))) {
      this.setState(prev => ({
        tasks: Object.entries(prev.tasks).reduce((newTasks, [task, value]) => {
          if (!availableTasks.includes(task)) {
            newTasks[task] = 0;
          } else {
            newTasks[task] = value;
          }
          return newTasks;
        }, {}),
      }));
    }
  };

  reset() {
    this.setState({ ...STATE });
  }

  // Getters
  get locale() {
    return this.props.locale;
  }

  get addressTypeId() {
    return this.props.addressTypes?.filter(t => t.name === 'delivery')[0].id;
  }

  get deliveryAddresses() {
    return this.state.creditorCompany?.addresses;
  }

  get propertyNames() {
    return Object.keys(this.props.values);
  }

  get homeAddress() {
    const homeTypeId = this.props.addressTypes?.filter(t => t.name === 'home')[0].id;
    return this.state.creditorCompany?.addresses.filter(a => a.typeId === homeTypeId);
  }

  get companySource() {
    return getPropByName(this.state.creditorCompany, 'company_from_eu');
  }

  get acceptCopyBody() {
    return this.props.acceptCopy();
  }

  get workflow() {
    if (!this.props.selectedWorkflowId || !this.props.availableWorkflows) return null;
    return this.props.availableWorkflows.find(w => w.id === this.props.selectedWorkflowId);
  }

  get attachedWorkflows() {
    return this.props.attachedWorkflows ?? [];
  }

  get vatPricesFieldsToBeReset() {
    let fields = [
      'financial_purchase_price_excl_vat_excl_bpm',
      'financial_purchase_price_incl_vat_excl_bpm',
      // 'financial_purchase_price_marge_bpm',
      'financial_purchase_price_incl_vat_bpm',
    ];

    switch (env.clientId) {
      case AppClientId.INDEWAL:
        break;
      case AppClientId.IDWLEASE:
        break;
      case AppClientId.IDWLEASE:
        break;
      case AppClientId.HARRY_NIJBOER:
        fields = ['financial_purchase_price_marge_excl_bpm', 'financial_purchase_price_marge_bpm'];
        break;
      case AppClientId.HOOIKAMMER:
        fields = ['financial_purchase_price_marge_excl_bpm', 'financial_purchase_price_marge_bpm'];
        break;
      case AppClientId.IDW_GMBH:
        break;
      case AppClientId.AUTOWIENTJES:
        fields = ['financial_purchase_price_marge_excl_bpm', 'financial_purchase_price_marge_bpm'];
        break;
      case AppClientId.AUTOHUISSALLAND:
        fields = ['financial_purchase_price_marge_excl_bpm', 'financial_purchase_price_marge_bpm'];
        break;
      case AppClientId.HILTERMANN:
        break;
    }

    return fields;
  }

  get margePricesFieldsToBeReset() {
    let fields = [
      'financial_purchase_price_marge_excl_bpm',
      'financial_purchase_price_marge_bpm',
      'financial_purchase_price_incl_vat_bpm',
    ];

    switch (env.clientId) {
      case AppClientId.INDEWAL:
        break;
      case AppClientId.IDWLEASE:
        break;
      case AppClientId.HARRY_NIJBOER:
        fields = ['financial_purchase_price_marge_excl_bpm', 'financial_purchase_price_marge_bpm'];
        break;
      case AppClientId.HOOIKAMMER:
        fields = ['financial_purchase_price_marge_excl_bpm', 'financial_purchase_price_marge_bpm'];
        break;
      case AppClientId.IDW_GMBH:
        break;
      case AppClientId.AUTOWIENTJES:
        fields = ['financial_purchase_price_marge_excl_bpm', 'financial_purchase_price_marge_bpm'];
        break;
      case AppClientId.AUTOHUISSALLAND:
        fields = ['financial_purchase_price_marge_excl_bpm', 'financial_purchase_price_marge_bpm'];
        break;
      case AppClientId.HILTERMANN:
        break;
    }

    return fields;
  }

  setDefaultFields(types) {
    if (
      env.clientId === AppClientId.INDEWAL ||
      env.clientId === AppClientId.HOOIKAMMER ||
      env.clientId === AppClientId.HILTERMANN ||
      !Object.values(AppClientId).includes(env.clientId)
    ) {
      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Passenger &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge
      ) {
        [
          // 'financial_purchase_price_marge_excl_bpm',
          'financial_purchase_price_excl_vat_excl_bpm',
          'financial_purchase_price_incl_vat_excl_bpm',
          'financial_purchase_price_incl_vat_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_marge_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge
      ) {
        [
          'financial_purchase_price_incl_vat_excl_bpm',
          // 'financial_purchase_price_marge_bpm',
          'financial_purchase_price_incl_vat_bpm',
          'financial_purchase_price_excl_vat_excl_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_marge_excl_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Passenger &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW
      ) {
        [
          'financial_purchase_price_marge_excl_bpm',
          // 'financial_purchase_price_excl_vat_excl_bpm',
          // 'financial_purchase_price_incl_vat_excl_bpm',
          'financial_purchase_price_marge_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_incl_vat_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW
      ) {
        [
          'financial_purchase_price_marge_excl_bpm',
          'financial_purchase_price_marge_bpm',
          // 'financial_purchase_price_incl_vat_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_excl_vat_excl_bpm', 'financial_purchase_price_incl_vat_excl_bpm']);
      }

      return types;
    }

    if (env.clientId === AppClientId.HOOIKAMMER) {
      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Passenger &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge
      ) {
        [
          // 'financial_purchase_price_marge_excl_bpm',
          'financial_purchase_price_excl_vat_excl_bpm',
          'financial_purchase_price_incl_vat_excl_bpm',
          'financial_purchase_price_incl_vat_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_marge_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge
      ) {
        [
          'financial_purchase_price_incl_vat_excl_bpm',
          // 'financial_purchase_price_marge_bpm',
          'financial_purchase_price_incl_vat_bpm',
          'financial_purchase_price_excl_vat_excl_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_marge_excl_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Passenger &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW
      ) {
        [
          'financial_purchase_price_marge_excl_bpm',
          // 'financial_purchase_price_excl_vat_excl_bpm',
          // 'financial_purchase_price_incl_vat_excl_bpm',
          'financial_purchase_price_marge_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_incl_vat_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW
      ) {
        [
          'financial_purchase_price_marge_excl_bpm',
          'financial_purchase_price_marge_bpm',
          // 'financial_purchase_price_incl_vat_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_excl_vat_excl_bpm', 'financial_purchase_price_incl_vat_excl_bpm']);
      }

      return types;
    }

    if (env.clientId === AppClientId.HARRY_NIJBOER) {
      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Passenger &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge
      ) {
        [
          // 'financial_purchase_price_marge_excl_bpm',
          'financial_purchase_price_excl_vat_excl_bpm',
          'financial_purchase_price_incl_vat_excl_bpm',
          'financial_purchase_price_incl_vat_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_marge_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge
      ) {
        [
          'financial_purchase_price_incl_vat_excl_bpm',
          // 'financial_purchase_price_marge_bpm',
          'financial_purchase_price_incl_vat_bpm',
          'financial_purchase_price_excl_vat_excl_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_marge_excl_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Passenger &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW
      ) {
        [
          'financial_purchase_price_marge_excl_bpm',
          // 'financial_purchase_price_excl_vat_excl_bpm',
          // 'financial_purchase_price_incl_vat_excl_bpm',
          'financial_purchase_price_marge_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_incl_vat_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW
      ) {
        [
          'financial_purchase_price_marge_excl_bpm',
          'financial_purchase_price_marge_bpm',
          // 'financial_purchase_price_incl_vat_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_excl_vat_excl_bpm', 'financial_purchase_price_incl_vat_excl_bpm']);
      }

      return types;
    }

    if (env.clientId === AppClientId.IDW_GMBH) {
      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Passenger &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge
      ) {
        [
          // 'financial_purchase_price_marge_excl_bpm',
          'financial_purchase_price_excl_vat_excl_bpm',
          'financial_purchase_price_incl_vat_excl_bpm',
          'financial_purchase_price_incl_vat_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_marge_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge
      ) {
        [
          'financial_purchase_price_incl_vat_excl_bpm',
          // 'financial_purchase_price_marge_bpm',
          'financial_purchase_price_incl_vat_bpm',
          'financial_purchase_price_excl_vat_excl_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_marge_excl_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Passenger &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW
      ) {
        [
          'financial_purchase_price_marge_excl_bpm',
          // 'financial_purchase_price_excl_vat_excl_bpm',
          // 'financial_purchase_price_incl_vat_excl_bpm',
          'financial_purchase_price_marge_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_incl_vat_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW
      ) {
        [
          'financial_purchase_price_marge_excl_bpm',
          'financial_purchase_price_marge_bpm',
          // 'financial_purchase_price_incl_vat_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_excl_vat_excl_bpm', 'financial_purchase_price_incl_vat_excl_bpm']);
      }

      return types;
    }

    if (
      env.clientId === AppClientId.AUTOWIENTJES ||
      env.clientId === AppClientId.AUTOHUISSALLAND ||
      env.clientId === AppClientId.HARRY_NIJBOER ||
      env.clientId === AppClientId.HOOIKAMMER
    ) {
      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Passenger &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge
      ) {
        [
          // 'financial_purchase_price_marge_excl_bpm',
          'financial_purchase_price_excl_vat_excl_bpm',
          'financial_purchase_price_incl_vat_excl_bpm',
          'financial_purchase_price_incl_vat_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_marge_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge
      ) {
        [
          'financial_purchase_price_incl_vat_excl_bpm',
          // 'financial_purchase_price_marge_bpm',
          'financial_purchase_price_incl_vat_bpm',
          'financial_purchase_price_excl_vat_excl_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_marge_excl_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Passenger &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW
      ) {
        [
          'financial_purchase_price_marge_excl_bpm',
          // 'financial_purchase_price_excl_vat_excl_bpm',
          // 'financial_purchase_price_incl_vat_excl_bpm',
          'financial_purchase_price_marge_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_incl_vat_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW
      ) {
        [
          'financial_purchase_price_marge_excl_bpm',
          'financial_purchase_price_marge_bpm',
          // 'financial_purchase_price_incl_vat_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_excl_vat_excl_bpm', 'financial_purchase_price_incl_vat_excl_bpm']);
      }

      return types;
    }

    return types;
  }

  getColumnTypes() {
    let types = [];
    switch (env.clientId) {
      case AppClientId.INDEWAL:
        types = ['vin', 'transport', 'extra_cost_transport_kosten_inkomend'];
        break;
      case AppClientId.IDWLEASE:
        types = ['vin', 'transport', 'vehicle_purpose', 'extra_cost_transport_kosten_inkomend'];
        break;
      case AppClientId.HARRY_NIJBOER:
        break;
      case AppClientId.HOOIKAMMER:
        types = ['workflowId'];
        break;
      case AppClientId.IDW_GMBH:
        types = ['vehicle_purpose', 'extra_cost_transport_kosten_inkomend'];
        break;
      case AppClientId.AUTOWIENTJES:
        types = [''];
        break;
      case AppClientId.AUTOHUISSALLAND:
        types = ['is_owner', 'make_tasks'];
        break;
      case AppClientId.HILTERMANN:
        types = ['workflowId', 'category_id'];
        break;
    }

    if (this.props.values?.make_tasks == '1') {
      types = types.concat(
        ...[
          'SALLAND_poetsen_compleet',
          'SALLAND_poetsen_binnenkant',
          'SALLAND_poetsen_buitenkant',
          'SALLAND_velgen_wisselen',
          'SALLAND_ozon_behandeling',
          'SALLAND_glascoating',
        ],
      );
    }

    if (this.props.values?.is_owner == '1') {
      types = types.concat(...['extra_cost_transport_kosten_inkomend']);
    }

    return types;
  }

  // Helper method to check if this is a commercial vehicle with date >= 2025 and BTW tax type
  isCommercialVehicle2025BTW() {
    const { values } = this.props;
    if (!values?.vehicle_purpose || !values?.tax_type) {
      return false;
    }

    const isCommercial = values.vehicle_purpose === VEHICLE_PURPOSE.Commercial;
    const isBTW = values.tax_type === VEHICLE_TAX_TYPE.BTW;
    const dateFirstAllowance = values.date_first_allowance;
    const is2025OrLater = dateFirstAllowance ? new Date(dateFirstAllowance).getFullYear() >= 2025 : true;

    return isCommercial && isBTW && is2025OrLater;
  }

  getFinancialTypes() {
    let types = ['vehicle_purpose', 'tax_type', 'buying_contact', 'rest_bpm', 'financial_bpm_gross'];

    // Special case for commercial vehicles 2025+ with BTW
    if (this.isCommercialVehicle2025BTW()) {
      // Clear other financial fields that shouldn't be visible
      [
        'financial_purchase_price_excl_vat_excl_bmp',
        'financial_purchase_price_incl_vat_excl_bmp',
        'financial_purchase_price_marge_bmp',
        'financial_purchase_price_marge_excl_bmp',
        'financial_purchase_price_incl_vat_bmp',
      ].map(type => this.props.setValue('', type));

      // For commercial vehicles 2025+ BTW, only show these fields
      return [
        'vehicle_purpose',
        'tax_type',
        'buying_contact',
        'rest_bpm',
        'financial_bpm_gross',
        'financial_purchase_price_incl_bpm_excl_btw',
      ];
    }

    if (env.clientId === AppClientId.HOOIKAMMER) {
      types = types.concat(...['brand_name', 'model_name', 'articlecode']);
      types = types.filter(type => !['vehicle_purpose', 'tax_type', 'rest_bpm', 'buying_contact'].includes(type));
    }
    if (env.clientId === AppClientId.HILTERMANN) {
      types = types.filter(type => !['rest_bpm', 'buying_contact'].includes(type));
    }
    if (!this.props.values?.tax_type) {
      [
        'financial_purchase_price_excl_vat_excl_bpm',
        'financial_purchase_price_incl_vat_excl_bpm',
        'financial_purchase_price_marge_bpm',
        'financial_purchase_price_marge_excl_bpm',
        'financial_purchase_price_incl_vat_bpm',
      ].map(type => this.props.setValue('', type));
    }

    if (!this.props.values?.vehicle_purpose) {
      ['financial_purchase_price_marge_bpm', 'financial_purchase_price_incl_vat_bpm'].map(type =>
        this.props.setValue('', type),
      );
    }

    if (this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge && this.props.values?.import === '1') {
      this.vatPricesFieldsToBeReset.map(type => this.props.setValue('', type));
      return types.concat(...['financial_purchase_price_marge_excl_bpm']);
    }

    if (this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW && this.props.values?.import === '1') {
      this.margePricesFieldsToBeReset.map(type => this.props.setValue('', type));
      return types.concat(...['financial_purchase_price_excl_vat_excl_bpm', 'financial_purchase_price_incl_vat_excl_bpm']);
    }

    if (
      this.props.values?.import === '0' &&
      this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Passenger &&
      this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge
    ) {
      [
        // 'financial_purchase_price_marge_excl_bpm',
        'financial_purchase_price_excl_vat_excl_bpm',
        'financial_purchase_price_incl_vat_excl_bpm',
        'financial_purchase_price_incl_vat_bpm',
      ].map(type => this.props.setValue('', type));
      return types.concat(...['financial_purchase_price_marge_bpm']);
    }

    if (
      this.props.values?.import === '0' &&
      this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial &&
      this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge
    ) {
      [
        'financial_purchase_price_incl_vat_excl_bpm',
        // 'financial_purchase_price_marge_bpm',
        'financial_purchase_price_incl_vat_bpm',
        'financial_purchase_price_excl_vat_excl_bpm',
      ].map(type => this.props.setValue('', type));
      return types.concat(...['financial_purchase_price_marge_excl_bpm']);
    }

    if (
      this.props.values?.import === '0' &&
      this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Passenger &&
      this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW
    ) {
      [
        'financial_purchase_price_marge_excl_bpm',
        // 'financial_purchase_price_excl_vat_excl_bpm',
        // 'financial_purchase_price_incl_vat_excl_bpm',
        'financial_purchase_price_marge_bpm',
      ].map(type => this.props.setValue('', type));
      return types.concat(...['financial_purchase_price_incl_vat_bpm']);
    }

    if (
      this.props.values?.import === '0' &&
      this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial &&
      this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW
    ) {
      [
        'financial_purchase_price_marge_excl_bpm',
        'financial_purchase_price_marge_bpm',
        // 'financial_purchase_price_incl_vat_bpm',
      ].map(type => this.props.setValue('', type));
      return types.concat(...['financial_purchase_price_excl_vat_excl_bpm', 'financial_purchase_price_incl_vat_excl_bpm']);
    }

    return types;
  }

  handleSetDeliveryAddress = a => {
    this.setState({ address: a });
    this.props.setValue(this.state.creditorCompany?.id, 'location_company_id');
    if (a?.postcode) {
      this.props.setValue(a?.postcode, 'transport_from_address_postcode');
    }
    return this.props.setValue(a.id, 'location_address_id');
  };

  // Helper method to check if a field is required
  isFieldRequired = fieldName => {
    const field = REQUIRED_FIELDS[fieldName];
    if (!field) return false;
    return field.condition(this.props.values, env.clientId);
  };

  // Helper method to get required field message
  getRequiredFieldMessage = fieldName => {
    const field = REQUIRED_FIELDS[fieldName];
    return field ? field.message : '';
  };

  // Refactored renderRequired method
  renderRequired = type => {
    if (this.isFieldRequired(type)) {
      return <div className="req-field-message">{this.getRequiredFieldMessage(type)}</div>;
    }
    return null;
  };

  save() {
    this.setState({ saveStrategy: 4 });
    this.props.onSave();
  }

  quickSave = () => {
    this.setState({ saveStrategy: 3 });
    this.props.onSave(() => {
      alert(`${this.lblStr('alert.success.vehicle_added')}`);
      this.props.fetchVehicles();
    }, 'quickSave');
  };

  saveAndCreateTransportOrder = () => {
    this.setState({ saveStrategy: 5 });
    this.props.onSave(() => {
      alert(`${this.lblStr('alert.success.vehicle_added')}`);
      // this.props.fetchVehicles();
    }, 'saveAndCreateTransportOrder');
  };

  addAndCopy = () => {
    this.setState({ saveStrategy: 2 });
    this.props.onSave(() => {
      this.props.setValue('', 'vin');
      this.props.setValue('', 'regplate');
      this.props.setValue('', 'rest_bpm');
      this.props.setValue('', 'outgoing_rest_bpm');
      alert(`${this.lblStr('alert.success.vehicle_added')}`);
    });
  };

  addAndNew = () => {
    this.setState({ saveStrategy: 1 });
    this.props.onSave(() => {
      this.props.setValue('', 'from_autotelex');
      this.props.back();
    }, 'addAndNew');
  };

  onSelectWorkflow(workflowId) {
    const workflow = this.attachedWorkflows.find(w => w.id === workflowId);
    const tasks = workflow?.tasks ?? [];
    const tasksState = tasks.reduce((prev, curr) => {
      prev[curr] = 1;
      return prev;
    }, {});
    this.setState({ tasks: tasksState });
  }

  saveAfterAcceptDuplicate = () => {
    if (this.props.oldVehicles) {
      this.props.oldVehicles?.map(vehicleId => {
        this.props.setVehicleProperty(vehicleId, 'old_vehicle', '1');
      });
    }
    switch (this.state.saveStrategy) {
      case 1:
        return () => {
          this.addAndNew();
        };
      case 2:
        return () => {
          this.addAndCopy();
        };
      case 3:
        return () => {
          this.quickSave();
        };
      case 4:
        return () => {
          this.save();
        };
      case 5:
        return () => {
          this.saveAndCreateTransportOrder();
        };
      default:
        return () => {};
    }
  };

  renderTaskCheckbox = t => (
    <HBox vCenter left style={{ gap: 10 }}>
      <CheckboxComponent
        checked={!!this.state.tasks[t] ? 1 : 0}
        onChange={() => {
          this.setState(
            prev => {
              return { tasks: { ...prev.tasks, [t]: prev.tasks[t] ? 0 : 1 } };
            },
            () => this.props.setValue(`${this.state.tasks[t]}`, t),
          );
        }}
        label={this.lbl(`workflows.details.tasks.${t}`)}
      />
      <span>{this.lbl(`workflows.details.tasks.${t}`)}</span>
    </HBox>
  );

  get mainModalFields() {
    let fields = [
      'regplate',
      'vin',
      'import',
      'ex_rental',
      'new_from_factory',
      'brand_name',
      'model_name',
      'buying_contact',
      'tax_type',
    ];

    switch (env.clientId) {
      case AppClientId.INDEWAL:
        fields = [
          'regplate',
          'vin',
          'import',
          'ex_rental',
          'new_from_factory',
          'brand_name',
          'model_name',
          'model_info',
          'mileage',
          'date_first_allowance',
        ];
        break;
      case AppClientId.IDWLEASE:
        break;
      case AppClientId.HARRY_NIJBOER:
        fields = ['regplate', 'vin', 'import', 'new_from_factory', 'brand_name', 'model_name', 'mileage'];
        break;
      case AppClientId.HOOIKAMMER:
        fields = ['regplate', 'vin', 'vehicle_purpose', 'tax_type', 'empty_weight', 'body_type'];
        break;
      case AppClientId.IDW_GMBH:
        break;
      case AppClientId.AUTOWIENTJES:
        fields = ['regplate', 'meldcode', 'vin', 'import', 'new_from_factory', 'brand_name', 'model_name', 'mileage'];
        break;
      case AppClientId.AUTOHUISSALLAND:
        fields = ['regplate', 'vin', 'import', 'new_from_factory', 'brand_name', 'model_name', 'mileage'];
        break;
      case AppClientId.HILTERMANN:
        fields = [
          'regplate',
          'vin',
          'articlecode',
          'brand_name',
          'model_name',
          'new_from_factory',
          // 'buying_contact',
          // 'transport',
          // 'ex_rental',
        ];
        break;
    }

    return fields;
  }

  isDeliverySectionVisible() {
    return ![AppClientId.AUTOWIENTJES, AppClientId.AUTOHUISSALLAND].includes(env.clientId);
  }

  isHiltermannMandatoryUnset() {
    if (env.clientId !== AppClientId.HILTERMANN) return false;
    return !this.props.values?.vehicle_purpose || !this.props.values?.workflowId;
  }

  isHooikammerMandatoryUnset() {
    if (env.clientId !== AppClientId.HOOIKAMMER) return false;
    return (!this.props.values?.vehicle_purpose || !this.props.values?.workflowId) && this.props.values?.creditor_company == '25';
  }

  isOverigDataColumnVisible() {
    return ![AppClientId.AUTOWIENTJES].includes(env.clientId);
  }

  renderDateExpectedField() {
    if ([AppClientId.HOOIKAMMER, AppClientId.HILTERMANN].includes(env.clientId)) return;

    return <VehicleCreateField key={'date_expected'} type={'date_expected'} />;
  }

  applyDisabled() {
    const financialTypes = this.getFinancialTypes();
    const hasMandatoryUnset = financialTypes.some(type => type.startsWith('financial_purchase') && !this.props.values[type]);
    const requiresDateExpected =
      this.props.values?.transport === 'is_available' || this.props.values?.transport === 'pickup';



    if (this.isHiltermannMandatoryUnset()) {
      return true;
    }

    if (this.isHooikammerMandatoryUnset()) {
      return true;
    }

 

    return (
      this.props.work ||
      !this.props.values?.creditor_company ||
      (this.props.tradeInVehicle && hasMandatoryUnset) ||
      ((!this.props.values?.vehicle_purpose || !this.props.values?.tax_type) && this.props.tradeInVehicle) ||
      (requiresDateExpected && !this.props.values?.date_expected)
    );
  }

  get availableTasks() {
    return (
      this.workflow?.tasks
        ?.filter(
          t =>
            this.props.values.vehicle_purpose &&
            (t.vehiclePurposes.includes(this.props.values.vehicle_purpose) || t.vehiclePurposes.includes('*')),
        )
        .map(t => t.name) ?? []
    );
  }

  get modalTitle() {
    let title = this.lblStr('vehicle.order.add_incoming_order');
    if (env.clientId === AppClientId.HOOIKAMMER) {
      title = this.lblStr('hooikammer.vehicle.order.add_incoming_order');
    }

    return title;
  }

  renderColumnTitle(column) {
    if (env.clientId === AppClientId.HOOIKAMMER) return;
    let title = '';

    switch (column) {
      case 1:
        title = 'vehicle_data';
        break;
      case 2:
        title = 'financial_data';
      case 3:
        title = 'overige_data';
      default:
        title = 'title';
    }

    return <h5>{this.lbl(`vehicle.order.add_incoming_order.${title}`)}</h5>;
  }

  renderBackButton() {
    if (env.clientId === AppClientId.HILTERMANN) return;
    return (
      <ButtonComponent style="ButtonSoftPrimaryGreen" onClick={this.props.handlePrev}>
        {this.lblStr('vehicle.btn.quick.back')}
      </ButtonComponent>
    );
  }

  render() {
    let disableMandatory = this.props.work;
    
   
    
    return (
      <ModalComponent
        size={window.innerWidth <= 768 ? 'sm' : 'xl'}
        className={styles.modal}
        onClose={this.props.reset}
        title={this.modalTitle}
      >
        <Container>
          <div className={styles.fieldsWrapper}>
            <VBox>
              <div className={styles.container}>
                {this.renderColumnTitle(1)}
                {this.state.creditorCompany &&
                  this.mainModalFields.map(type => (
                    <Permission permission={type === 'tax_type' ? PURCHASING_PRICES_CRUD : null} key={type}>
                      <div>
                        <VehicleCreateField
                          key={type}
                          type={type}
                          vehicle_id={this.props.vehicle_id}
                          loggedInUserId={this.props.loggedInUserId}
                          creditorCompanyId={this.props.values?.creditor_company}
                          companySource={this.companySource}
                          companyType={this.state?.creditorCompany?.company_type}
                          availableWorkflows={this.attachedWorkflows}
                          onSelectWorkflow={this.onSelectWorkflow.bind(this)}
                        />
                      </div>
                    </Permission>
                  ))}
                {/* {this.workflow && <List>{this.availableTasks.map(t => this.renderTaskCheckbox(t))}</List>} */}
              </div>
            </VBox>
            <VBox>
              <div className={styles.container}>
                {this.renderColumnTitle(2)}

                {this.state.creditorCompany && (
                  <>
                    {this.getFinancialTypes().map(type => {
                      // Check if the type starts with "financial_purchase"
                      const isFinancialPurchase = type.startsWith('financial_purchase');

                      return (
                        <Permission permission={type === VEHICLE_PURPOSE.PropertyName ? PURCHASING_PRICES_CRUD : null}>
                          {isFinancialPurchase && this.props.tradeInVehicle && (
                            <div className="req-field-message">{'*'}</div>
                          )}
                          {type === 'vehicle_purpose' && this.renderRequired(type)}
                          <VehicleCreateField
                            key={type}
                            type={type}
                            mandatory={isFinancialPurchase}
                            vehicle_id={this.props.vehicle_id}
                            companySource={this.companySource}
                            companyType={this.state?.creditorCompany?.company_type}
                            availableWorkflows={this.attachedWorkflows}
                            onSelectWorkflow={this.onSelectWorkflow.bind(this)}
                          />
                        </Permission>
                      );
                    })}
                  </>
                )}
              </div>
            </VBox>

            {this.isOverigDataColumnVisible() && (
              <VBox>
                <div className={styles.container}>
                  <h5>Overige data</h5>
                  {this.state.creditorCompany &&
                    this.getColumnTypes().map(type => {
                      if (type === 'extra_cost_transport_kosten_inkomend') {
                        return (
                          this.props.config?.appClientId == AUTOHUISSALLAND_INSTALATION.APP_CLIENT_ID && (
                            <VehicleCreateField
                              key={type}
                              value="80"
                              type={type}
                              vehicle_id={this.props.vehicle_id}
                              companySource={this.companySource}
                              companyType={this.state?.creditorCompany?.company_type}
                              availableWorkflows={this.attachedWorkflows}
                              onSelectWorkflow={this.onSelectWorkflow.bind(this)}
                            />
                          )
                        );
                      }
                      if (type === 'workflowId') {
                        return (
                          <>
                            {this.renderRequired(type)}
                            <VehicleCreateField
                              key={type}
                              type={type}
                              vehicle_id={this.props.vehicle_id}
                              companySource={this.companySource}
                              companyType={this.state?.creditorCompany?.company_type}
                              availableWorkflows={this.attachedWorkflows}
                              onSelectWorkflow={this.onSelectWorkflow.bind(this)}
                            />
                          </>
                        );
                      }
                      return (
                        <Permission permission={type === VEHICLE_PURPOSE.PropertyName ? PURCHASING_PRICES_CRUD : null}>
                          {type === 'is_owner' && <div className="req-field-message">{'Eigenaar is verplicht *'}</div>}

                          {type && (
                            <VehicleCreateField
                              key={type}
                              type={type}
                              vehicle_id={this.props.vehicle_id}
                              companySource={this.companySource}
                              companyType={this.state?.creditorCompany?.company_type}
                              availableWorkflows={this.attachedWorkflows}
                              onSelectWorkflow={this.onSelectWorkflow.bind(this)}
                            />
                          )}
                        </Permission>
                      );
                    })}
                  {this.isDeliverySectionVisible() && (
                    <>
                      <div>
                        <HBox left flexWrap flip={window.innerWidth < 768} style={{ gap: 10 }} className={'address-block'}>
                          {(this.props.values?.transport === 'is_available' || this.props.values?.transport === 'pickup') &&
                            this.deliveryAddresses &&
                            this.deliveryAddresses?.map(address => (
                              <>
                                <Address
                                  key={`${address?.id}`}
                                  å
                                  onClick={() => address.country && this.handleSetDeliveryAddress(address)}
                                  isActive={this.state.address?.id === address?.id}
                                >
                                  <VBox left>
                                    <HBox vCenter>
                                      <h3 className="name">{this.lbl(`address.type.${address?.type?.name || 'other'}`)}</h3>
                                      <CheckboxComponent
                                        disabled={!address.country}
                                        checked={this.state.address?.id === address?.id}
                                      />
                                    </HBox>
                                    <VBox className="address" left>
                                      <div>{address?.addressLine1}</div>
                                      <div>
                                        {address?.postcode} {address?.city}
                                      </div>
                                      <div>{translateCountry(address.country?.name, this.locale)}</div>
                                      {!address.country && (
                                        <div className="req-field-message">{'Country is required *'}</div>
                                      )}
                                    </VBox>
                                  </VBox>
                                </Address>
                              </>
                            ))}
                          {(this.props.values?.transport === 'is_available' ||
                            this.props.values?.transport === 'pickup') && (
                            <div className="calendar-block">{this.renderDateExpectedField()}</div>
                          )}
                        </HBox>
                      </div>
                    </>
                  )}
                </div>
              </VBox>
            )}
          </div>
          <VBox left>
            {this.acceptCopyBody?.isVisible && (
              <HBox vCenter left className={styles.buttonSmallContainer}>
                <span className="req-field-message">
                  {"You're about to add a car that's already in Vindat, do you want to continue?"}
                </span>
                <div className="d-flex gap-2">
                  <Button className={styles.buttonNo} small inline onClick={this.acceptCopyBody?.cancel}>
                    {this.lblStr('vehicle.filter.no')}
                  </Button>
                  <Button
                    small
                    className={styles.buttonYes}
                    inline
                    isPrimary
                    onClick={() => this.acceptCopyBody?.confirm(this.saveAfterAcceptDuplicate())}
                  >
                    {this.lblStr('vehicle.filter.yes')}
                  </Button>
                </div>
              </HBox>
            )}

            {this.props.workVehicleCreate ? (
              <Modal onClose={() => {}}>
                <HBox center>
                  <strong>{this.lbl('vehicle.create.loading')}</strong>
                </HBox>
                <HBox center>
                  <Loader />
                </HBox>
              </Modal>
            ) : null}
          </VBox>

          <div className={styles.buttonContainer}>
            <div className={styles.buttonContainer}>
              <div className={styles.buttonContainerItemBlock}>
                {' '}
                <ButtonComponent style="ButtonSoftDelete" onClick={this.props.reset}>
                  {this.lblStr('cancel')}
                </ButtonComponent>
                {this.renderBackButton()}
              </div>
              {!this.props.tradeInVehicle && (
                <div className={styles.buttonContainerItemBlock}>
                  <ButtonComponent style="ButtonSoftPrimary" disabled={this.applyDisabled()} small onClick={this.addAndNew}>
                    {this.lblStr('vehicle.btn.add.new')}
                  </ButtonComponent>
                  <ButtonComponent style="ButtonSoftPrimary" disabled={this.applyDisabled()} small onClick={this.addAndCopy}>
                    {this.lblStr('vehicle.btn.add.copy')}
                  </ButtonComponent>
                  <ButtonComponent style="ButtonSoftPrimary" disabled={this.applyDisabled()} small onClick={this.quickSave}>
                    {this.lblStr('vehicle.btn.quick.save')}
                  </ButtonComponent>
                </div>
              )}{' '}
              {/* <ButtonComponent
                style="ButtonSoftPrimary"
                disabled={disableMandatory}
                small

                onClick={this.saveAndCreateTransportOrder}
              >
                {this.lblStr('vehicle.btn.save.saveAndCreateTransportOrder')}
              </ButtonComponent> */}
              <ButtonComponent
                style="ButtonSoftPrimary"
                type="submit"
                disabled={this.applyDisabled()}
                small
                onClick={this.save.bind(this)}
              >
                {this.lblStr('vehicle.btn.save.continue')}
              </ButtonComponent>
            </div>
          </div>
        </Container>
      </ModalComponent>
    );
  }
}

AddVehicleModalBaseComp.propTypes = {
  intl: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  fetch: PropTypes.func.isRequired,
  getCompanyWorkflows: PropTypes.func.isRequired,
  fetchWorkflows: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  setNewVehicleValue: PropTypes.func.isRequired,
  setNewVehicle: PropTypes.func.isRequired,
  setVehicleProperty: PropTypes.func.isRequired,
  calculatePurchasePriceInclVatExclBPM: PropTypes.func.isRequired,
  updateAddress: PropTypes.func.isRequired,
  values: PropTypes.object,
  creditorCompany: PropTypes.object,
  creditorCompanyId: PropTypes.string,
  tradeInVehicle: PropTypes.bool,
  selectedWorkflowId: PropTypes.string,
  availableWorkflows: PropTypes.array,
  attachedWorkflows: PropTypes.array,
  addressTypes: PropTypes.array,
  locale: PropTypes.string,
  acceptCopy: PropTypes.func,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      REQUEST_COMPANIES,
      REQUEST_HOME_COMPANY_USERS,
      CALCULATE_PURCHASE_PRICES_INCL_VAT_EXCL_BPM,
      REQUEST_VEHICLE_CREATE,
      REQUEST_WORKFLOWS_FILTER,
      REQUEST_WORKFLOWS,
      REQUEST_COMPANY_WORKFLOWS,
    ]),
    workVehicleCreate: selectWork(REQUEST_VEHICLE_CREATE),
    loggedInUserId: selectUserId(),
    values: selectNewVehicle(),
    creditorCompany: selectCompany(ownProps.creditorCompanyId),
    addressTypes: selectAddressTypes(),
    config: selectConfig(),
    availableWorkflows: selectWorkflows(),
    selectedWorkflowId: selectNewVehicleValue('workflowId'),
    attachedWorkflows: selectCompanyWorkflows(),
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchCompanies());
    },
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewVehicleValue(name, value));
    },
    resetValues(values, name = null) {
      values.map(type => dispatch(setNewVehicleValue(type, '')));
    },
    setVehicleProperty(vehicleId, propertyName, propertyValue) {
      dispatch(setVehicleProperty(vehicleId, propertyName, propertyValue));
    },
    calculatePurchasePrice(enteredAmounts, callback) {
      dispatch(calculatePurchasePriceInclVatExclBPM(enteredAmounts, callback));
    },
    updateAddress(companyId, addressId, addressDto, callback) {
      dispatch(updateAddress(companyId, addressId, addressDto, callback));
    },
    fetchVehicles() {
      dispatch(fetchVehicles());
    },
    setNewVehicle() {
      dispatch(setNewVehicle());
    },
    fetchWorkflows() {
      dispatch(fetchWorkflows(0, 1000));
    },
    // setCompanyToWorkflowFilters() {
    //   dispatch(changeWorkflowFilter('companyId', ownProps.creditorCompanyId));
    // },
    getCompanyWorkflows() {
      if (ownProps.creditorCompanyId) dispatch(getCompanyWorkflows(ownProps.creditorCompanyId));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const AddVehicleModalBase = compose(withConnect, withRouter, injectIntl)(AddVehicleModalBaseComp);
